<!-- eslint-disable max-len -->
<template>
  <div>
    <div v-if="!isLoading">
      <div class="wrap-title-component">
        {{ titleComponent }}
      </div>
      <h5 class="mb-4 text-capitalize">
        {{ detailComponent.title }}
      </h5>

      <!-- Search option -->
      <div
        v-if="hasSearchOptions"
        class="form-master mb-3"
      >
        <b-row>
          <b-col
            v-for="field in detailComponent.search_options_list"
            :key="field.field_data_key"
            md="6"
          >
            <b-form-group style="margin-bottom: 10px;">
              <label class="label-form-base"> {{ field.name }} </label>
              <field-preview
                :column="field"
                :use-drag-icon="false"
                :is-search="true"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <div class="d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <button
            v-if="hasSearchOptions"
            class="button-blue mr-2"
          >
            Search
          </button>
          <button class="button-gray mr-2">Export Data</button>
          <button
            v-if="hasSearchOptions"
            class="button-clear"
          >
            Clear Filter
          </button>
        </div>

        <button
          v-if="useAdvanceReport"
          class="button-activity"
        >
          <img
            src="@/assets/icon/activity.svg"
            width="13"
            height="13"
            class="mr-1"
          >
          See Activity
        </button>
      </div>

      <v-client-table
        v-if="showTable"
        :data="[]"
        :columns="columns"
        :options="tableOptions"
        class="jTable"
      />
    </div>

    <div
      v-else
      class="skeleton-component"
    />
  </div>
</template>

<script>
/* eslint-disable max-len, no-nested-ternary */
import FieldPreview from '@/views/experience-manager-v2/partials/FieldPreview';
import jMixComponentMultiDetailView from '@/mixins/form-ui-v2/jMixComponentMultiDetailView';

export default {
  components: {
    FieldPreview,
  },

  mixins: [jMixComponentMultiDetailView],

  props: {
    type: {
      type: String,
      default: '',
    },
    forDetailParent: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      columns: [],
      showTable: false,
      tableOptions: {
        texts: {
          limit: 'Rows per page',
        },
        headings: {},
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: [],
        filterable: true,
        debounce: 1000,
        perPage: 10,
        perPageValues: [10, 20, 50, 100],
      },
    };
  },

  computed: {
    hasSearchOptions() {
      return this.detailComponent && this.detailComponent.search_options_list ? this.detailComponent.search_options_list.length > 0 : false;
    },

    useAdvanceReport() {
      return this.detailComponent.is_use_advance_report;
    },
  },

  methods: {
    async getDetailComponent() {
      const response = await this.requestDataComponent();
      if (response) {
        this.detailComponent = response.data.data[0].export_view;
        this.setDataColumns();
        this.isLoading = false;
      }
    },

    setDataColumns() {
      const dataColumns = this.detailComponent.sheet && this.detailComponent.sheet.length > 0 ? this.detailComponent.sheet[0].main_columns : this.detailComponent.columns;
      const filterColumn = dataColumns.filter(f => f.is_filter);

      filterColumn.forEach((e) => {
        this.tableOptions.headings[`${e.key}`] = e.name.toUpperCase();
      });

      this.columns = filterColumn.map(f => f.key);
      this.showTable = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @mixin button {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 85px;
    padding: 7px 20px;
    box-shadow: none;
    border: 1px solid transparent;
    border-radius: 4px;
    font-family: 'Poppins-Medium';
    font-size: 12px;
  }
  .button-blue {
    @include button;
    background-color: #1A85E4;
    color: white;
  }
  .button-gray {
    @include button;
    background-color: #989898;
    color: white;
    opacity: 0.5;
  }
  .button-clear {
    @include button;
    background-color: white;
    color: #1A85E4;
  }
  .button-activity {
    @include button;
    background-color: white;
    color: #606060;
    border-color: #E7E7E7;
  }
</style>



// WEBPACK FOOTER //
// src/components/dummy/DummyExportView.vue